import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'MG',
  name: 'Martina G.',
  location: 'Buenos Aires',
  text: 'Conseguí mi primer cliente en la semana 2. Usé exactamente el script del Tomo 5 y me respondió en menos de una hora. Cobré USD 80 por algo que me llevó 3 horas.',
  color: 'bg-electric'
}, {
  initials: 'LP',
  name: 'Lucas P.',
  location: 'Córdoba',
  text: 'Cerré mis primeros 3 clientes mensuales en el primer mes. Los mensajes del Bono 1 son una locura. Nunca pensé que iba a cobrar en dólares tan rápido.',
  color: 'bg-energy'
}, {
  initials: 'RM',
  name: 'Romina M.',
  location: 'Rosario',
  text: 'Pasé de no saber nada de freelancing a tener 4 clientes recurrentes en 6 semanas. El sistema funciona. Solo hay que ejecutarlo.',
  color: 'bg-gold'
}];
export function Testimonials() {
  return <section className="pt-6 pb-12 border-b border-petroleum bg-graphite/50" data-id="element-671">
      <div className="container mx-auto px-4" data-id="element-672">
        {/* Social Proof Header */}
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="mb-10 flex justify-center" data-id="element-673">
          <div className="inline-flex items-center gap-4 md:gap-6 bg-petroleum/80 backdrop-blur-sm border border-electric/20 rounded-full pl-3 pr-5 md:pl-4 md:pr-7 py-2.5 md:py-3 shadow-lg shadow-electric/5" data-id="element-674">
            {/* Avatars */}
            <div className="flex -space-x-2.5" data-id="element-675">
              {[1, 2, 3, 4].map(i => <div key={i} className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-gradient-to-br from-electric/30 to-petroleum border-2 border-petroleum flex items-center justify-center text-[11px] md:text-xs font-bold text-white" data-id="element-676">
                  {String.fromCharCode(64 + i)}
                </div>)}
            </div>

            {/* Divider */}
            <span className="w-px h-8 md:h-9 bg-gradient-to-b from-transparent via-electric/30 to-transparent" data-id="element-677"></span>

            {/* Rating */}
            <div className="flex flex-col items-start leading-tight" data-id="element-678">
              <div className="flex items-center gap-1.5" data-id="element-679">
                <div className="flex gap-0.5 text-gold" data-id="element-680">
                  {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-3.5 h-3.5 md:w-4 md:h-4 fill-gold" data-id="element-681" />)}
                </div>
                <span className="text-white font-bold text-sm md:text-base" data-id="element-682">
                  4.9
                </span>
                <span className="text-textsecondary text-xs md:text-sm" data-id="element-683">
                  /5
                </span>
              </div>
              <span className="text-[10px] md:text-xs text-textsecondary mt-0.5" data-id="element-684">
                <span className="text-electric font-semibold" data-id="element-685">+500</span>{' '}
                freelancers ya lo tienen
              </span>
            </div>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-686">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-petroleum border border-electric/10 rounded-xl p-6 hover:border-electric/30 transition-colors" data-id="element-687">
              <div className="flex items-center gap-4 mb-4" data-id="element-688">
                <div className={`w-12 h-12 rounded-full ${t.color} flex items-center justify-center text-graphite font-bold text-lg`} data-id="element-689">
                  {t.initials}
                </div>
                <div data-id="element-690">
                  <div className="flex gap-1 mb-1" data-id="element-691">
                    {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-gold fill-gold" data-id="element-692" />)}
                  </div>
                  <div className="text-sm text-textsecondary" data-id="element-693">
                    <span className="text-white font-medium" data-id="element-694">{t.name}</span> •{' '}
                    {t.location}
                  </div>
                </div>
              </div>
              <p className="text-textsecondary italic" data-id="element-695">"{t.text}"</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}